document.addEventListener("DOMContentLoaded", function () {
    const productImages = document.querySelectorAll(".media-gallery__item img");

    productImages.forEach((img) => {
        const container = img.parentElement;

        container.style.overflow = "hidden";
        img.style.transition = "none"; // Disable default transitions for smooth movement
        img.style.transformOrigin = "center center";
        
        container.addEventListener("mousemove", function (event) {
            const rect = img.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            img.style.transform = "scale(2)"; // Adjust zoom level (2x)
            img.style.transformOrigin = `${x}% ${y}%`; // Focus zoom on cursor location
        });

        container.addEventListener("mouseleave", function () {
            img.style.transform = "scale(1)";
            img.style.transformOrigin = "center center";
        });
    });
});
